import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Box, Button, Flex, Group, Image, Stack, Text, Title } from '@mantine/core';
import GrainMotif from '@/components/common/GrainMotif';
import { IconArrowRight } from '@tabler/icons-react';
import Benefits from '@/components/landing/Benefits';
import { ROUTES } from '@/routes/paths';

// Hero как в оригинале: слева узкая фото-полоса (машина) во всю высоту блока, справа — зелёная
// панель с заголовком, value-prop, CTA и тремя преимуществами (строкой под кнопками).
export default function HeroSection() {
  const { t } = useTranslation();

  return (
    <Box bg="brand.7" c="white" className="on-dark">
      <Flex direction={{ base: 'column', md: 'row' }} align="stretch">
        <Box w={{ base: '100%', md: '28%' }} style={{ overflow: 'hidden' }}>
          <Image
            src="/images/banner.webp"
            alt=""
            fit="cover"
            w="100%"
            h={{ base: 240, sm: 340, md: '100%' }}
            style={{ objectPosition: 'left' }}
          />
        </Box>

        <Box flex="1" py={{ base: 'xl', md: 56 }} px={{ base: 'md', md: 48 }} pos="relative" style={{ overflow: 'hidden' }}>
          {/* Водяной зерно-мотив — фирменная фоновая графика (см. GrainMotif). */}
          <GrainMotif variant="ear" size={300} color="rgba(255,255,255,0.04)" style={{ right: 160, bottom: -120 }} />
          <Stack gap={48} justify="center" h="100%" pos="relative">
            <Stack gap="lg" maw={680}>
              <Title order={1} fz={{ base: 30, sm: 44 }} lh={1.15} c="white">
                {t('landing.hero.title')}
              </Title>
              <Text fz={{ base: 'sm', sm: 'md' }} c="gray.2">
                {t('landing.hero.text')}
              </Text>
              <Group mt="sm">
                <Button
                  component={Link}
                  to={ROUTES.REGISTER}
                  color="lime.4"
                  c="brand.9"
                  size="md"
                  rightSection={<IconArrowRight size={18} />}
                >
                  {t('landing.hero.ctaPrimary')}
                </Button>
                <Button component={Link} to={ROUTES.LOGIN} variant="white" c="brand.8" size="md">
                  {t('landing.hero.ctaSecondary')}
                </Button>
              </Group>
            </Stack>

            <Benefits />
          </Stack>
        </Box>
      </Flex>
    </Box>
  );
}
